module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAX0AAAACAgMAAADJFORiAAAADFBMVEXn5uZAOjxFP0Dm5uZSFhk3AAAABHRSTlPou7vZkW0DvwAAAE9JREFUCNe1irENwDAMw/IkA8R7B/uKPuETMkRX5LTqiRLQQEmjgRZQEg8wSTjMBgfisDOj1y6LmqkNmn1YuLeYFZFegaJkuuTj8447fuV+GkoryxPfjzEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h1-9.png
// module id = gGOm
// module chunks = 1